import { Box, Button, Center, Heading, VStack } from "@chakra-ui/react";
import { forwardRef } from "react";

interface SectionTitleProps {
    onGoToTeam: () => void;
}

export const SectionTitle = forwardRef<HTMLDivElement, SectionTitleProps>(
    ({ onGoToTeam }, ref) => {
        return (
            <Box
                ref={ref}
                h="100vh"
                w="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                className="landing__header"
            >
                <Center w="100%" color="white">
                    <VStack spacing={8}>
                        <Heading
                            as="h1"
                            noOfLines={2}
                            textAlign={"center"}
                            letterSpacing={"0.2em"}
                            style={{
                                fontSize: "7vw",
                            }}
                        >
                            𝓻𝓮IMAGINA<br />
                            URBANO
                        </Heading>
                        <Button
                            variant="outline"
                            color="white"
                            borderColor="white"
                            _hover={{ bg: "whiteAlpha.200" }}
                            letterSpacing="0.15em"
                            fontSize="1.2vw"
                            px={8}
                            py={6}
                            onClick={onGoToTeam}
                        >
                            Equipo
                        </Button>
                    </VStack>
                </Center>
            </Box>
        );
    }
);
